import { Button, Flex, Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FunctionComponent } from "react";
import { EditFormTemplateActionBar } from "../../../components/ActionBar";
import { AutomaticMessageFormType } from "./schemas";
type Props = {
  isPreview: boolean;
  onPreviewClicked: () => void;
  onBackClicked: () => void;
  formId: string;
  isViewOnly: boolean;
  hasChanges: boolean;
  onClearChanges: () => void;
  isSubmitting: boolean;
};

/**
 * When editing a Message Template, users can preview their changes.
 * Going between editing and preview looks like a navigation event, but is not.
 * The parent page simply toggles the edit page and preview page.
 */
export const EditMessageTemplateActionBar: FunctionComponent<Props> = (
  props
) => {
  const formik = useFormikContext<AutomaticMessageFormType>();

  const {
    isPreview,
    onPreviewClicked,
    onBackClicked,
    formId,
    isViewOnly,
    hasChanges,
    onClearChanges,
    isSubmitting,
  } = props;

  return (
    <EditFormTemplateActionBar hasChanges={hasChanges}>
      <Button variant="outline" onClick={onBackClicked} colorScheme="gray">
        Back
      </Button>

      <Flex direction="column" gap={2}>
        <Flex gap={2}>
          {hasChanges && (
            <Button
              variant="ghost"
              colorScheme="gray"
              onClick={onClearChanges}
              gridColumn="3"
            >
              Clear unpublished changes
            </Button>
          )}

          {isPreview ? (
            <Button
              form={formId}
              type="submit"
              isDisabled={
                isViewOnly || !formik.isValid || !hasChanges || isSubmitting
              }
              isLoading={isSubmitting}
            >
              Save
            </Button>
          ) : (
            <Button
              type="button"
              onClick={(e) => {
                // Prevent the form from being submitted
                e.preventDefault();
                onPreviewClicked();
              }}
              isLoading={isSubmitting}
            >
              Preview and save
            </Button>
          )}
        </Flex>
        {hasChanges && (
          <Text textAlign="right" fontSize="xs" color="gray.500">
            Unpublished changes
          </Text>
        )}
      </Flex>
    </EditFormTemplateActionBar>
  );
};
